// extracted by mini-css-extract-plugin
export default {"AttachmentCollection":"HbSQxCbNvqDXtWEG9b1s","item":"agjk_fULMHERS12f7P5e"};